import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var Bounce = /*#__PURE__*/function () {
  function Bounce() {
    _classCallCheck(this, Bounce);
    this.distance = 200;
  }
  _createClass(Bounce, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.distance !== undefined) {
        this.distance = data.distance;
      }
    }
  }]);
  return Bounce;
}();